import { render, staticRenderFns } from "./WalmartPreviewShare.vue?vue&type=template&id=fb4560b2&scoped=true"
import script from "./WalmartPreviewShare.vue?vue&type=script&lang=js"
export * from "./WalmartPreviewShare.vue?vue&type=script&lang=js"
import style0 from "./WalmartPreviewShare.vue?vue&type=style&index=0&id=fb4560b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4560b2",
  null
  
)

export default component.exports